import { ActivityIndicator, StyleSheet, TextInput, View } from 'react-native';
import { useEffect, useMemo, useState, VFC } from 'react';
import debounce from 'lodash.debounce';
import { genShadowStyle } from '../utils/shadows';

type Props = {
  password: string;
  passwordChanged: (password: string) => void;
  isLoading: boolean;
};

export const PasswordField: VFC<Props> = ({ password, passwordChanged, isLoading }) => {
  return (
    <View style={styles.container}>
      <TextInput
        style={styles.field}
        placeholder={'Fill in password'}
        value={password}
        autoCompleteType={'password'}
        textContentType={'password'}
        keyboardType={'default'}
        autoCapitalize={'none'}
        autoCorrect={false}
        secureTextEntry={true}
        onChangeText={passwordChanged}
      />
      <ActivityIndicator style={{ opacity: isLoading ? 1.0 : 0.0 }} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    ...genShadowStyle(2),
    backgroundColor: 'white',
    padding: 15,
    borderRadius: 8,
    flexDirection: 'row',
    width: '100%',
    marginTop: 20,
  },
  field: {
    flex: 1,
    marginRight: 10,
  },
});
